const locale = {
    //common
    LOCALE_CODE: 'en-US',
    LANGUAGE_SELECT: 'Select Language',
    ERRORS_DETECTED: 'Errors have been detected!',
    CLOSE: 'Close',
    SUCCESS: 'Success!',
    LAST_FOUR_PHONE: 'Last 4 Digits of Phone Number',
    VALID_LAST_FOUR_PHONE: 'Must provide a valid last 4 digits of phone number.',
    AMOUNT: 'Amount',
    SUBMIT: 'Submit',
    ACCOUNT_NUMBER: 'Account Number',
    VALID_AMOUNT: 'Must provide a valid amount.',
    VALID_ACCOUNT_NUMBER: 'Must provide a valid account number.',
    INVALID_LAST_FOUR_PHONE: 'The provided last four digits of the customer phone number does not match any of the phone numbers we have on file.',
    REFRESH: 'Refresh',

    //homepage
    WELCOME: 'Welcome to the Ambit Payment Lobby',
    HOME_REDIRECT: 'You have arrived here by mistake. Please return to our homepage and try to navigate again.',
    RETURN_TO_AMBIT: 'Return to Ambit',
    //donations
    RETURN_TO_AMBIT_CARES: 'Return to Ambit Cares',
    VERIFYING: 'Verifying...',
    MISSING_DONOR_TYPE: 'Missing Donor Type',
    MISSING_DONOR_NUMBER: 'Missing Donor Number',
    MISSING_DONOR_NAME: 'Missing Donor Name',
    MISSING_AMOUNT: 'Missing Amount',
    DONATION_FORMAT: 'Incorrectly formatted donation amount: ',
    DONATION_VERIFY: 'verify your account information, please contact customer care at <a href="tel:8772826284">877-282-6284.</a>',
    DONATION_ZIP: '(provided zipcode does not match account information)',
    DONATION_ZIP_MISMATCH: 'Zip-code mismatch for Donor',
    DONATION_ACCOUNT_ERROR: 'Error Accessing Customer Account',
    DONATION_ACCOUNT_EXCEPTION: 'Exception Accessing Customer Account',
    CUSTOMER: 'Customer',
    DONOR: 'Donor',
    CONSULTANT: 'Consultant',
    //finalpayment
    HOME: 'Home',
    CONTACT: 'Contact',
    AMBIT_COLLECTIONS: 'Ambit Collections',
    LDC: 'LDC Identifier',
    VALID_LDC: 'Must provide a valid LDC Identifier',
    EMAIL_TEXT: 'Please Complete the form to send an email to our collections department',
    ENTER_NAME: 'Enter your name here',
    ENTER_EMAIL: 'Enter you email address here',
    ENTER_MESSAGE: 'Enter your message here',
    VALID_EMAIL: 'Must provide a valid email.',
    VALID_MESSAGE: 'Must provide a valid message.',
    VALID_NAME: 'Must provide a valid name.',
    EMAIL_SENT: 'Your email has been sent!',
    EMAIL_ERROR: '<span>We are unable to send your message at this time. You can contact customer service at <a href="tel:8772826284">877-282-6284.</a></span>',
    INELIGIBLE_ACCOUNT_TYPE: 'Your account is not eligible for this payment method, if you feel you have received this message in error, please contact Ambit Energy Collections at <a href="mailto:collectionsnontx@ambitenergy.com">collectionsnontx@ambitenergy.com</a>',
    INVALID_LDC: 'Error, Location identifier (LDC) and Ambit account do not match. To verify your account information, please contact customer care at <a href="tel:8772826284">877-282-6284.</a>',
    INELIGIBLE_ACCOUNT_LOCATION: 'Your account location is not eligible for this payment form, if you feel you have received this message in error, please contact Ambit Energy Collections at <a href="mailto:collectionsnontx@ambitenergy.com">collectionsnontx@ambitenergy.com</a>',
    //QuickPay
    ATTENTION_NICOR_CUSTOMERS: "Attention Nicor Customers!",
    OTHER_AMOUNT: 'Other Amount',
    PAY_NOW: 'Pay Now',
    BILLING_ZIP: 'Billing Zip Code',
    RETURN_HOME: 'Return to Homepage',
    VALID_ZIP: 'Must provide a valid zip code.',
    MAKE_PAYMENT: 'Make a Payment',
    ONE_TIME_PAYMENT: 'You will be able to make a one-time payment by Checking/Savings Account or by Credit/DebitCard.',
    //This will need to be updated
    APPLY_CCFEE: ' (a $2.50 electronic processing fee applies)',
    CURRENT_BALANCE: 'Current Balance: ',
    TOTAL_ACCOUNT_BALANCE: 'Total Account Balance: ',
    CURRENT_BALANCE_DUE: 'Current Balance Due: ',
    AUTOPAY: 'Enroll in our Automatic Payment program and save the credit/debit card transaction fees. Sign up through your online account at <a href = "www.ambitenergy.com">www.ambitenergy.com</a>',
    //AGREE_CCFEE: 'I agree to a $2.50 electronic processing fee to payments made by Credit/DebitCard.',
    AGREE_ELECTRONICFEE: 'I agree to a $2.50 electronic processing fee for this one-time payment.',
    AGREE_BILLEDELECTRONICFEE:'I agree to a $2.50 electronic processing fee that will appear on my next invoice for this one-time payment.',
    REINSTATE_AMOUNT: 'Reinstatement Amount: ',
    PAST_DUE: 'Past Due: ',
    ACCOUNT_INFO_NOT_VERIFIED: 'We could not verify your account number and/or your billing address zip code. Please try again or call our Customer Service Representative at ',
    DEENERGIZED: 'Your account is currently De-Energized.  To reinstate service, please contact Ambit Customer Care at <a href="tel:8772826284">877-282-6284.</a>.',
    NO_COMMERCIAL: 'Quick-Pay is reserved for residential and small business customers only.  To make payment for this account, please contact the Account Manager – Mary Voltin at <a href="tel:2144610935">214-461-0935.</a>.',
    CURRENT_BALANCE_MESSAGE: 'Our records indicate that your current balance is ${0}.',
    CURRENT_BALANCE_PAST_DUE_MESSAGE: 'Our records indicate that your account balance is ${0} of which ${1} is past due.',
    ACCOUNT_BALANCE_MESSAGE: 'Our records indicate that your account balance is ',
    REINSTATE_AMOUNT_MESSAGE: 'Amount Required to Reinstate Service is ${0}.',
    PAYMENTPLAN_BALANCE_AMOUNT_MESSAGE: 'PaymentPlan balance is ${0}.',
    PAYMENTPLAN_BALANCE_AMOUNT_DUE_MESSAGE: 'PaymentPlan balance is ${0}, of which ${1} is due.',
    AVOID_DISCONNECT: 'Amount to Avoid Disconnect: ',
    AVOID_DISCONNECT_MESSAGE: 'Amount to Avoid Disconnect: ${0}.',
    //Bluenet
    AMOUNT_TO_PAY: 'Amount to Pay',
    TOTAL_CHARGED: 'Total Amount Charged: ${0}.',
    WAIVE_CCFEE: 'Waive Electronic Processing Fee of ${0}.',
    WAIVE_AGENTFEE: 'Waive Agent Pay-By-Phone Fee of ${0}.',
    CREDIT_WARNING: 'You are about to pay more than your current balance and a credit will be applied to your account.',
    NOT_AUTHENTICATED: 'The provided request is not authenticated. Please try again with a valid token.',
    ENROLL_AUTOPAY: 'Enroll in Automatic Payment program on the next page. You must pay at least your current balance to be eligible.',
    INELIGIBLE_OVERPAY: 'Your account is not eligible for overpayment.',
    //Payment Plan
    ENROLL_IN_PAYMENT_PLAN: 'Enroll in Payment Plan',
    CURRENT_PAYMENT_PLAN: 'Current Payment Plan',
    PAYMENT_PLAN_HISTORY: 'Payment Plan History',
    PAYMENT_PLAN: 'Payment Plan',
    ENROLLMENT_DATE: 'Enrollment Date',
    STATUS: 'Status',
    END_DATE: 'End Date',
    INVOICE_DATE: 'Invoice Date',
    DPP_AGREEMENT1: 'By entering into this Agreement, you understand Ambit Energy will put a switch-hold on your account. A switch hold means that you will not be able to buy electricity from other companies until you pay this past due amount. The switch-hold will be removed after your final payment on this past due amount is processed. While a switch-hold applies, if you are disconnected for not paying, you will need to pay Ambit Energy to get your electricity turned back on. Your monthly invoice will contain the remaining balance of your Deferred Payment Plan or you can call Ambit Energy for the remaining amount at any time. Your current invoice must be paid along with the scheduled DPP installments to avoid disconnection.',
    DPP_AGREEMENT2: 'Do you agree to these terms?',
    DPP_AGREEMENT3: 'Here are a few things you need to know about your Ambit Deferred Payment Plan, or DPP. Your first payment installment needs to be posted by 12am today with Ambit Energy or at one of our payment locations. Credit card payments for your first installment do not have payment processing fees, but your subsequent installment payments will have processing fees applied. We will send you a letter within approximately 24 hours via regular mail detailing your Deferred Payment Plan. We will not send you any additional reminder statements or call you regarding your remaining installment payments. If you default on your Deferred Payment Plan, we can set you up on a new Deferred Payment Plan. However, you will have to pay the amount due of all your invoices previously covered under your old Deferred Payment Plan. It is important to pay your current monthly invoices in full moving forward, along with your DPP installments, by the due date to avoid defaulting your agreement and any interruption in service. Please remember to look for your letter detailing your DPP.',
    DPP_AGREEMENT4: 'Check the box once the above script has been read and the customer agrees to the terms. (An enroll button will appear once this is checked.)',
    //ReversePayment
    REVERSIBLE_PAYMENTS: 'Reversible Payments',
    REVERSIBLE_PAYMENT_DATE: 'Payment Date',
    REVERSIBLE_AMOUNT: 'Amount',
    REVERSIBLE_TRANSACTION_REFERENCE_NUMBER: 'Transaction Reference Number',
    REVERSIBLE_ERROR_GET: 'Reversible payments were not found for customer',
    REVERSIBLE_ERROR_INVALID_AMOUNT: 'Payment amount is invalid',
    REVERSIBLE_ERROR_PROCESS: 'Payment reversal failed',
    REVERSE: 'Reverse',
    REVERSE_SUCCESS: 'Payment reversal succeeded',
    REVERSE_INVALID: 'Selected payment is invalid'

}

export default locale;